import axios from "axios";
import useGlobalStore from "../stores/globalStore";
import ReactGA from "react-ga4";

export default function useHandleOrder() {
  //Stores
  const {
    selectedNetwork,
    selectedBroadband,
    selectedTvPackages,
    selectedTvBasePackage,
    selectedFlexChannels,
    selectedBroadbandEquipment,
    selectedTvEquipment,
    selectedSecurity,
    digiCardAmount,
    selectedShipping,
  } = useGlobalStore((state) => state);

  //Form state
  const {
    personalnumberRef,
    nameRef,
    addressRef,
    postnumberRef,
    cityRef,
    emailRef,
    phoneRef,
    secondaddressRef,
    startDateInternetRef,
    startDateTvRef,
    messageRef,
    iAcceptPrivacy,
    toggleIsSending,
  } = useGlobalStore((state) => state);

  //Functions
  const generateList = (title, items) => {
    if (!items || items.length === 0) {
      return "";
    }

    return `
        <p style='margin-bottom:4px; '> <strong>${title}:</strong> </p>
        <ul style='margin: 0px;'>
            ${items.map((item) => `<li>${item.title} ${item.price ? " - " + item.price + "kr" : ""}</li>`).join("")}
        </ul>
    `;
  };

  const generateListMonth = (title, items) => {
    if (!items || items.length === 0) {
      return "";
    }

    return `
        <p style='margin-bottom:4px; '> <strong>${title}:</strong> </p>
        <ul style='margin: 0px;'>
            ${items.map((item) => `<li>${item.title} ${item.price ? " - " + item.price + "kr/mån" : ""}</li>`).join("")}
        </ul>
    `;
  };

  //Email string
  let emailString = `
  <div style="color:#333333; font-family: 'Arial', sans-serif;">
  <h1 style='color: #004493; text-transform: capitalize;'><span style='text-transform: capitalize;'>${
    selectedNetwork.title
  }<span></h1>
     <div>
        <h2 style='color: #cb1216'>Detaljer</h2>
        <p style='margin: 0;'><strong>Title:</strong> ${nameRef}</p>
        <p style='margin: 0;'><strong>Email:</strong> ${emailRef}</p>
        <p style='margin: 0;'><strong>Personnummer:</strong> ${personalnumberRef}</p>
        <p style='margin: 0;'><strong>Adress:</strong> ${addressRef}</p>
        <p style='margin: 0;'><strong>Postnumber:</strong> ${postnumberRef}</p>
        <p style='margin: 0;'><strong>Ort:</strong> ${cityRef}</p>
        <p style='margin: 0;'><strong>Telefon:</strong> ${phoneRef}</p>
        <p style='margin: 0;'><strong>Fastighetsadress:</strong> ${secondaddressRef}</p>
        <p style='margin: 0;'><strong>Startdatum internet:</strong> ${startDateInternetRef ?? ""}</p>
        <p style='margin: 0;'><strong>Startdatum tv:</strong> ${startDateTvRef ?? ""}</p>
        <p style='margin: 0;'><strong>Meddelande:</strong> ${messageRef}</p>
        <p style='margin: 0;'>${
          iAcceptPrivacy ? "Har accepterat privacy checkbox" : "Har inte accepterat privacy checkbox"
        }</p>
     </div>

     <div>
    <h2 style='color: #cb1216'>Beställning</h2>

    ${
      (selectedBroadband && selectedBroadband.title != "Nej tack!")
        ? `<p><strong>Bredband:</strong> ${selectedBroadband.title} ${
            (selectedBroadband.discount_price
              ? " - " + selectedBroadband.discount_price
              : " - " + selectedBroadband.price) + "kr/mån"
          }</p>`
        : ""
    }

    ${
      digiCardAmount != 0
        ? `<p><strong>Digital kort</strong> x ${digiCardAmount} - ${digiCardAmount * 35}kr/mån</p>`
        : ""
    }
    <p><strong>Tv Baspaket:</strong> ${selectedTvBasePackage?.title}</p>
    ${generateListMonth("Tv kanal-paket", selectedTvPackages)}
    ${selectedFlexChannels.length > 0 ? generateList("Flexkanaler", selectedFlexChannels) : ""}
    ${generateList("Bredband tillbehör", selectedBroadbandEquipment)}
    ${generateList("Tv tillbehör", selectedTvEquipment)}

    ${
      (selectedSecurity && selectedSecurity.title != "Nej tack!")
        ? `<p><strong>Övrigt:</strong> ${selectedSecurity.title} ${
            (selectedSecurity.discount_price
              ? " - " + selectedSecurity.discount_price
              : " - " + selectedSecurity.price) + "kr/mån"
          }</p>`
        : ""
    }


    ${ ((selectedTvEquipment[0].id != 5555555 || selectedBroadbandEquipment[0].id != 4444444) && selectedShipping) ? `<p><strong>${selectedShipping.title}</strong> - ${selectedShipping.price}kr</p>` : ""}
</div>
</div>
  `;

  const handleOrder = async () => {
    toggleIsSending();
    // Correct function name to 'handleOrder'
    try {
      // Send order to API
      const response = await axios({
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/phpmailer.php`,
        headers: { "content-type": "application/json" },
        data: {
          fullOrder: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
        },
      });

      if (response.data !== "sending") {
        throw new Error(response.data);
      }

      // Logging to db
      const loggerResponseSuccess = await axios({
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/order-logger.php`,
        headers: { "content-type": "application/json" },
        data: {
          personNr: personalnumberRef,
          msg: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
          status: "Skickat",
        },
      });

      //GA4 tracking
      ReactGA.event({
        category: "sending order",
        action: `Sent order form ${selectedNetwork.title}`,
        label: `Order form ${selectedNetwork.title}`, // optional
        nonInteraction: false, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
      });

      //Redirect
      window.location.href = "https://www.teleservice.net/tack-for-bestallning/";

      toggleIsSending();
    } catch (error) {
      console.error(error.message);
      // Logging to db
      const loggerResponseError = await axios({
        method: "POST",
        url: `../../../wp-content/plugins/tel-privata-tjanster-plugin/API/order-logger.php`,
        headers: { "content-type": "application/json" },
        data: {
          personNr: personalnumberRef,
          errorMsg: error.message,
          msg: emailString,
          formName: selectedNetwork.title,
          email: emailRef,
          status: "Ej skickat",
        },
      });
      toggleIsSending();
    }
  };

  return handleOrder;
}
